<template>
  <div class="agreement-container">
    <!-- 直接渲染长文本，保留换行与格式 -->
    <div class="agreement-content" v-html="agreementText"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agreementText: 
	  `
	  两双筷子用户服务协议
	  欢迎您与两双筷子（详见定义条款）共同签署本《用户服务协议》（下称“本协议”）并使用两双筷子相关服务。
	  两双筷子在此特别提醒用户认真阅读、充分理解本协议中各条款，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对本协议内容或页面提示信息有疑问，请勿进行下一步操作。
	  您的注册、登录、使用等行为将视为您已对本协议充分阅读、理解并接受本协议的全部内容，并与两双筷子达成一致，成为两双筷子的“用户”。
	  如果您未申请注册流程，或者在本协议生效前已成为两双筷子的注册用户，则您名下任何账户通过访问和/或使用两双筷子系统、网站、应用程序及其他各类端口，即视为您表示同意接受本协议的全部内容，否则请您停止访问或使用两双筷子服务。
	  1. 定义
	  1.1两双筷子系统：指两双筷子合法所有或运营的网站、客户端、应用程序等系统，包括但不限于掌上两双筷子、红云等客户端、小程序及相关网站。
	  1.2两双筷子服务：两双筷子基于互联网，以包含客户端、网站等在内的各种形态（包括未来技术发展出现的新的服务形态）向用户提供的各项服务。
	  1.3设备绑定：指您将您购买的智能收银一体机、两双筷子智能收银一体机软件进步绑定并开通智能收银一体机相关功能的行为。
	  2. 账户的注册、使用和注销
	  2.1用户资格
	  2.1.1您确认，在您开始使用/注册程序使用两双筷子服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
	  2.1.2如果您是未成年人，请在您的监护人的同意和指导下访问和/或使用我们的服务。
	  2.2账户说明
	  2.2.1当您按照注册页面提示填写信息、阅读并同意本协议及客《两双筷子隐私政策》且完成全部注册程序后，您可获得两双筷子账号并成为两双筷子的用户。
	  2.2.2您有权使用您设置或确认的两双筷子用户名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录两双筷子系统。
	  2.2.3由于用户账户关联用户信息，仅当有法律明文规定、司法裁定或经两双筷子同意，并符合两双筷子相关规则规定的用户账户转让流程的情况下，您才可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则由此产生的一切责任均由您承担。
	  2.2.4为使您更好地使用两双筷子的各项服务，我们建议您按照相关法律法规规定及我们产品页面的提示完成实名认证或资质认证。
	  2.2.5如您的账户长期未登录，两双筷子有权予以进行注销等清理，您的账户将不能再登录任一两双筷子系统终端，相应服务同时终止。两双筷子在对此类账户进行清理前，将以包括但不限于网站公告、站内消息、客户端推送信息等方式通知您。
	  2.3注册信息管理
	  2.3.1真实合法
	  2.3.1.1在使用两双筷子服务时，您应当按两双筷子系统或产品页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便两双筷子在必要时与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。
	  2.3.1.2您所设置的用户名不得违反国家法律法规及两双筷子关于用户名的管理规定，否则两双筷子可对您的用户名进行暂停使用或注销等处理。用户员名的回收不影响您以邮箱、手机号码登录两双筷子系统并使用两双筷子服务
	  2.3.2更新维护
	  2.3.2.1您应当及时更新您提供的信息，在法律法规有明确规定或基于为您提供第三方服务需求要求两双筷子对部分用户的信息进行核实的情况下，两双筷子将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。
	  2.3.2.2如两双筷子按您最后一次提供的信息与您联系未果、您未按照两双筷子的要求及时提供信息、您提供的信息存在明显不实的，您将承担因此对您自身、他人及两双筷子造成的全部损失与不利后果。两双筷子可对您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部两双筷子服务，两双筷子对此不承担责任。
	  2.3.2.3 两双筷子对于您用户信息及个人信息的收集、使用、保护等内容详见《两双筷子隐私政策》。
	  2.4账户安全规范
	  2.4.1您的账户为您自行设置并由您保管。建议您务必保管好您的帐户（如您为非自然人用户，请您同时加强内部人员管理，确保您的工作人员能妥善保管您的账户信息及账户密码安全），并确保您在每个上网时段结束时退出登录并以正确步骤离开两双筷子系统。
	  2.4.2除两双筷子存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。
	  2.4.3您的账户只限您本人或您指定的下属员工使用，不得出借或分享他人使用。当您的账户遭到未经授权的使用时，您应当立即通知我们，否则未经授权的使用行为均视为您本人的行为，您将自行承担所有由此导致的损失及后果。
	  2.4.4账户因您主动泄漏或因您遭受他人攻击、诈骗等行为导致的损失及后果，两双筷子对此并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
	  2.4.5如发现任何未经授权使用您账户登录两双筷子系统或其他可能导致您账户遭窃、遗失的情况，建议您立即通知两双筷子。您理解两双筷子对您的任何请求采取行动均需要合理时间，且两双筷子应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除两双筷子存在主观过错外，两双筷子对在采取行动前已经产生的后果不承担任何责任。
	  3. 两双筷子服务内容及规范
	  3.1两双筷子提供的服务
	  3.1.1两双筷子向您提供包括但不限于以下服务：
	  （一）两双筷子直接所有或运营的任何客户端及网站；
	  （二）其他由两双筷子运营并适合提供的服务。
	  （三）两双筷子公司会同第三方合作伙伴共同向您提供的服务。
	  3.1.2两双筷子提供的两双筷子服务均仅限于您在两双筷子系统或平台使用，未经两双筷子明确同意或安排，任何以恶意破解等非法手段将两双筷子服务与两双筷子公司分离的行为，均不属于本协议中约定的两双筷子服务。由此引起的一切法律后果由行为人负责，两双筷子将依法追究行为人的法律责任。
	  3.1.3除了两双筷子明确可由第三方授权登录两双筷子相关客户端外，两双筷子网站官方公布的方式为下载、注册、登录、使用两双筷子服务的唯一合法方式，您通过其他未经两双筷子明确认可的渠道、途径、方式获取的两双筷子服务（包括且不限于账户、积分、经验值、积分商品、兑换商品、赠品、下载等）均为非法取得，两双筷子概不承认其效力，且一经发现两双筷子有权立即做出删除、取消、清零、封号等处理，任何因此导致的一切不利后果均由您自行承担。
	  3.1.4两双筷子有权向您公告（包括但不限于弹出页面、网站公告、站内消息、短信通知等方式）以修改、替换、升级与两双筷子服务相关的任何软件、系统或服务。如果您不同意或者不接受两双筷子软件、系统或服务的修改、替换、升级，请直接拒绝、停止、取消，否则视为您同意并接受两双筷子软件、系统或服务的修改、替代、升级，同时该同意并接受的行为仍受本协议约束。
	  3.1.5您理解并认可，您使用两双筷子系统或两双筷子账户所获得的使用记录、订阅、收藏、积分、经验值、成长值、等级、身份标识、赠券、虚拟积分商品、虚拟兑换商品、虚拟赠品、下载等衍生物，您确认对其不享有所有权（除非两双筷子另有公告说明），两双筷子许可您按照两双筷子规则进行使用，两双筷子对上述衍生物不承担任何赔偿责任。
	  3.1.6您同意并保证，不得利用两双筷子服务或其衍生物（包括但不限于账户、积分、等级、积分商品、活动赠品、下载等服务）进行倒卖、转手、置换、抵押有价交易等方式非法牟利。您不会利用两双筷子服务或其衍生物侵犯他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段窃取、盗用他人的帐户、积分、积分商品等。
	  3.1.7您理解并认可，如果您通过第三方支付工具在两双筷子账户支付或充值后可能产生的任何商业风险（包括但不限于不法分子利用您帐户或银行卡等有价卡等进行违法活动），该等风险均有可能给您造成相应的经济损失，两双筷子在充分履行其在本协议项下义务和符合法律规定的前提下，不对您的前述风险和损失承担任何责任。
	  3.2服务规范
	  3.2.1您可通过两双筷子系统服务在两双筷子系统各类用户端上传、发布或传输相关内容，包括但不限于文字、软件、程序、图形、图片、声音、音乐、视频、音视频、链接等信息或其他资料（下称“内容”），但您需对此内容承担相关的法律责任。
	  3.2.2为方便您使用两双筷子服务及两双筷子与其他合作伙伴共同向您提供的服务，您授权两双筷子在您注册和使用两双筷子服务期间提供、形成的信息传递给两双筷子的合作伙伴及其他相关方，或从其他相关方获取您在注册、使用相关服务期间提供、形成的信息。
	  3.2.3您理解并知晓在使用两双筷子服务时，所接触的内容和信息来源广泛，两双筷子无法对该内容和信息的准确性、真实性、可用性、安全性、完整性和正当性负责。您理解并认可您可能会接触到不正确的、令人不快的、不适当的或令人厌恶的内容和信息，您不会以此追究两双筷子的相关责任。两双筷子不对用户在两双筷子系统上传、发布或传输的任何内容和信息背书、推荐或表达观点，也不对任何内容和信息的错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。但如您认为其他用户所上传、发布、传输的任何内容侵犯到您的合法权益，您可立即通知我们，我们会按照法律法规规定及我们与用户的约定进行相应处理。
	  3.2.4您同意两双筷子在提供服务的过程中以各种方式投放商业性广告或其他任何类型的商业信息（包括但不限于在两双筷子的任何位置上投放广告，在您上传、传播的内容中投放广告），您同意接受两双筷子通过电子邮件、站内短信、手机短信、微信、钉钉、网站公告或其他方式向您发送促销或其他相关商业信息。
	  3.2.5您同意在使用两双筷子服务过程中，遵守以下法律法规：《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规。在任何情况下，两双筷子一旦合理地认为您的行为可能违反上述法律、法规，可以在任何时候，不经事先通知终止向您提供服务。您应了解国际互联网的无国界性，应特别注意遵守当地所有有关的法律和法规。
	  3.3禁止的内容
	  3.3.1您理解并保证您在两双筷子上传、发布或传输的内容（包括您的账户名称等信息）不含有以下内容：
	  （一）违反国家法律法规禁止性规定的；
	  （二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
	  （三）欺诈、虚假、不准确或存在误导性的；
	  （四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
	  （五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
	  （六）存在可能破坏、篡改、删除、影响两双筷子任何系统正常运行或未经授权秘密获取两双筷子及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
	  （七）其他违背社会公共利益或公共道德或依据相关两双筷子协议、规则的规定不适合在两双筷子系统上发布的。
	  3.3.2如果您上传、发布或传输的内容含有以上违反法律法规的信息或内容的，或者侵犯任何第三方的合法权益，两双筷子有权进行独立判断并采取相应措施，包括但不限于通过技术手段删除相关内容。同时，两双筷子有权视您的行为性质，采取包括但不限于暂停或终止向您提供服务，追究法律责任等措施。您将直接承担以上导致的一切不利后果。如因此给两双筷子造成不利后果的，您应负责消除影响，并且赔偿两双筷子因此导致的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。
	  3.4禁止的行为
	  3.4.1您理解并保证不就两双筷子服务进行下列的禁止的行为，也不允许任何人利用您的账户进行下列行为：
	  （一）在注册账户时，或使用两双筷子服务时，冒充他人，或您讹称与任何人或实体有联系（包括设置失实的帐户名称或接入另一用户的账户）；
	  （二）伪造标题或以其他方式操控内容，使他人误认为该内容为两双筷子所传输；
	  （三）将无权传输的内容（例如内部资料、机密资料）进行上传、发布、发送电子邮件或以其他方式传输；
	  （四）发送任何未获邀约或未经授权的垃圾电邮、广告或宣传资料，或任何其他商业通讯；
	  （五）跟踪或以其他方式骚扰他人；
	  （六）参与任何非法或有可能非法（由两双筷子判断）的活动或交易，包括传授犯罪方法、出售任何非法药物、洗钱活动、诈骗等；
	  （七）赌博、提供赌博数据或透过任何方法诱使他人参与赌博活动；
	  （八）使用或利用两双筷子知识产权（包括我们的商标、品牌、标志、任何其他专有数据或任何网页的布局或设计），或在其他方面侵犯两双筷子任何知识产权（包括试图对两双筷子客户端或所使用的软件进行逆向工程）；
	  （九）通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入两双筷子服务、收集或处理通过两双筷子服务所提供的内容；
	  （十）参与任何“框架”、“镜像”或其他技术，目的是模仿两双筷子服务的外观和功能；
	  （十一）干预或试图干预任何用户或任何其他方接入两双筷子服务；
	  （十二）故意散播病毒、网络蠕虫、特洛伊木马病毒、已损毁的档案或其他恶意代码或项目；
	  （十三）未经他人明确同意，分享或发布该等人士可识别个人身份的资料；
	  （十四）探究或测试两双筷子服务、系统或其他用户的系统是否容易入侵攻击，或在其他方面规避（或试图规避）两双筷子服务、系统或其他用户的系统的任何安全功能；
	  （十五）对两双筷子服务所用的软件进行解编、反向编译或逆向工程，或试图作出上述事项；
	  （十六）为破坏或滥用的目的开设多个账户，或恶意上传重复的、无效的大容量数据和信息；
	  （十七）故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力
	  3.5 自动收货规则
	  门店通过本APP采购商品、物料、设备等，供应商发货后3天内，门店未手动操作确认收货的，系统将自动确认收货。自动收货完成后，视为门店已对商品数量、质量验收无误，订单正式完成并生效，门店不得以未收货、未验收等理由拒绝付款、申请退款或提出异议。
	  4．第三方链接
	  两双筷子服务可能会包含与其他网站或资源的链接，如支付宝、钉钉、微信、信贷服务。两双筷子对于前述网站或资源的内容、隐私政策和活动，无权控制、审查或修改，因而也不承担任何责任。两双筷子建议您在离开两双筷子系统，访问其他网站或资源前仔细阅读其服务条款和隐私政策。
	  5．信息收集及使用
	  5.1信息的收集
	  5.1.1为了向用户提供更好、更优、更个性化的服务，您同意并授权两双筷子公司根据本协议及其他法律法规合法、正当地收集并使用您在两双筷子系统上所留下的与两双筷子服务相关的必要信息。
	  5.1.2当您在两双筷子系统创建账户使用服务或通过第三方平台授权登陆时，两双筷子会记录您向两双筷子提供的各类信息，包括但不限于地理位置、手机号、相应的店铺信息名称、店铺地址、员工信息、菜品类目、价格、经营数据、营销数据、用户消费数据信息；同时，两双筷子还会记录您在使用两双筷子服务时提供的信息，例如消费金额、所点菜品、您在两双筷子系统用户终端发布的信息、搜索关键词信息、您与两双筷子客服联系时所提供的相关信息、您参与店铺测评时向两双筷子发送的各类答复信息。
	  5.1.3更多关于用户信息及个人信息的收集内容详见《两双筷子隐私政策》（点击此处）。
	  5.2信息的使用
	  5.2.1当您与两双筷子或两双筷子第三方合作伙伴之间互动时，本着共同向用户提供服务及改进服务质量的合理需要，也为了风险防控，以及保护各方的合法权益，用户同意两双筷子公司或第三方合作伙伴在必要时将以上必要信息用于如下用途：
	  5.2.1.1在您使用两双筷子服务过程中，为可能向您提供定制化服务，并持续维护、改善、优化这些服务，包括但不限于对您的信息进行分析和处理、或将您的信息用于数据建模、大数据分析等；
	  5.2.1.2用于预防、发现、调查欺诈、危害安全、非法或违反与两双筷子相关协议、政策或规则的行为，以保护您、两双筷子公司其他用户、两双筷子公司关联方或第三方合作伙伴的合法权益；
	  5.2.2 我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解您如何使用两双筷子服务或让公众了解两双筷子服务的总体使用趋势；
	  5.2.3我们可能会将某项服务的信息与来自其他服务的信息结合起来，以便为您提供更优质、个性化的服务、内容和建议。
	  5.2.4 如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规、及本协议要求。另外，如我们需从第三方处获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性。同时，我们也会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。
	  5.2.5我们会根据相关法律法规及监管规定对您的信息承担保护义务，并对关联公司或第三方合作伙伴进行数据安全能力审核，要求他们按照本协议及相关隐私政策采取保密和安全措施。
	  5.2.6 您同意两双筷子使用您个人信息（包括但不限于电话号码、邮件、短信等方式）向您推销/推广两双筷子或两双筷子关联机构、两双筷子合作方的产品、服务。
	  5.3 信息的共享
	  5.3.1基于向您提供营销及运营服务，提升您使用两双筷子商业操作系统的体验，您同意，两双筷子可能与关联公司合作共同向您提供的某项服务，基于共同向您提供该项服务，您同意将您的经营数据、信息，包括但不限于您的基本信息、经营信息、商品明细、订单明细、支付信息、会员信息，由两双筷子及关联公司共同处理，在此场景中，您理解，前述信息将不可避免的传输至两双筷子关联公司，并由关联公司进行处理，您对数据传输及处理表示同意，两双筷子关联公司应采取合理措施确保您的数据安全并不向第三人进行披露。
	  5.3.2为了改善产品服务，让您得到更好的用户体验，两双筷子会将数据处理及储存交由两双筷子关联公司进行处理。基于对数据的储存及处理，您使用两双筷子平台及软件服务过程中提供、形成的信息，包括但不限于收支数据、商品明细、订单明细、支付方式、会员等信息，会传输至实际处理的关联公司，您对此表示同意并认可。
	  6．知识产权
	  6.1除非另有约定或两双筷子另行声明，两双筷子的所有内容（用户依法享有版权的内容除外）、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利，均归两双筷子所有。未经两双筷子许可，任何人不得擅自使用（包括但不限于复制、传播、展示、镜像、上载、下载、修改、出租）。
	  6.2两双筷子、品牌等文字、图形及其组合，以及两双筷子的其他标识、徵记、产品和服务名称均为两双筷子在中国或其它国家的商标，未经两双筷子书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。
	  6.3两双筷子对其专有内容、原创内容和其他通过授权取得的独占或独家内容享有完全知识产权。未经两双筷子许可，任何单位和个人不得私自转载、传播和提供观看服务或者有其他侵犯两双筷子知识产权的行为，否则将承担所有相关的法律责任。
	  7．用户的违约及处理
	  7.1违约认定
	  发生如下情形之一的，视为您违约：
	  7.1.1使用两双筷子服务时违反有关法律法规规定的；
	  7.1.2违反本协议或本协议补充协议约定的。
	  7.2为适应互联网行业发展和满足海量用户对高效优质服务的需求，您理解并同意，两双筷子可在两双筷子规则中约定违约认定的程序和标准。如：两双筷子可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。
	  7.3违约处理措施
	  7.3.1您在两双筷子发布的内容和信息构成违约的，两双筷子可根据相应规则立即对相应内容和信息进行删除、屏蔽等处理或对您的账户进行暂停使用、查封、删除等处理。
	  7.3.2您在两双筷子系统上实施的行为，或虽未在两双筷子系统上实施但对两双筷子系统及其他用户产生影响的行为构成违约的，两双筷子可依据相应规则对您的账户执行限制参加活动、中止向您提供部分或全部服务等处理措施。如您的行为构成根本违约的，两双筷子可查封您的账户，终止向您提供服务。
	  7.3.3如果您在两双筷子系统上的行为违反相关的法律法规，两双筷子可依法向相关主管机关报告并提交您的使用记录和其他信息。
	  7.3.4两双筷子可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在两双筷子平台上予以公示
	  7.4赔偿责任
	  7.4.1如您的行为使两双筷子遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿两双筷子的上述全部损失。
	  7.4.2如您的行为使两双筷子遭受第三人主张权利，两双筷子可在对第三人承担金钱给付等义务后就全部损失向您追偿。
	  7.5特别约定
	  7.5.1两双筷子负责"按现状"和"可得到"的状态向您提供两双筷子服务。两双筷子依法律规定承担相应义务，但无法对由于信息网络设备维护、连接故障，电脑、通讯或其他系统的故障，黑客活动、计算机病毒、电力故障，通讯网络故障、罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方原因，以及在两双筷子已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素而给您造成的损害结果承担责任。
	  7.5.2两双筷子通过中华人民共和国境内的设施控制和提供两双筷子服务，两双筷子不担保控制或提供的服务在其他国家或地区是适当的、可行的，任何在其他司法辖区使用两双筷子服务的用户应自行确保其遵守当地的法律法规，两双筷子对此不承担任何责任。
	  8．协议的变更
	  8.1两双筷子可根据国家法律法规变化及两双筷子服务变化的需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过本协议约定的方式通知您。
	  8.2如您对变更事项不同意的，您应当于变更事项确定的生效之日起停止使用两双筷子服务；如您在变更事项生效后仍继续使用两双筷子服务，则视为您同意已生效的变更事项。
	  9．通知
	  您同意两双筷子以以下合理的方式向您送达各类通知：
	  （一）公示的文案；
	  （二）站内消息、弹出消息、客户端推送的消息；
	  （三）根据您预留于两双筷子系统的联系方式发出的电子邮件、手机短信、微信、函件等。
	  你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
	  10．协议的终止
	  10.1终止的情形
	  您有权通过以下任一方式终止本协议：
	  （一）在满足两双筷子公示的账户注销等清理条件时您通过网站注销您的账户的；
	  （二）变更事项生效前您停止使用并明示不愿接受变更事项的；
	  （三）您明示不愿继续使用两双筷子服务，且符合终止条件的。
	  出现以下情况时，两双筷子可以本协议所列的方式通知您终止本协议：
	  （一）您违反本协议约定，两双筷子依据违约条款终止本协议的；
	  （二）您转让本人账户、盗用他人账户、发布违禁内容和信息、骗取他人财物、采取不正当手段谋利等行为，两双筷子依据两双筷子规则对您的账户予以查封的；
	  （三）除上述情形外，因您多次违反两双筷子规则相关规定且情节严重，两双筷子依据两双筷子规则对您的账户予以查封的；
	  （四）您的账户被两双筷子依据本协议进行注销等清理的；
	  （五）您在两双筷子有侵犯他人合法权益或其他严重违法违约行为的；
	  （六）其它根据相关法律法规两双筷子应当终止服务的情况。
	  10.2协议终止后的处理
	  本协议终止后，除法律有明确规定外，两双筷子无义务向您或您指定的第三方披露您账户中的任何信息。
	  本协议终止后，两双筷子享有下列权利：
	  （一）停止收集和使用您的个人信息，但可继续保存您留存于两双筷子系统的其他内容和信息；
	  （二）对于您过往的违约行为，两双筷子仍可依据本协议向您追究违约责任。
	  11．法律适用、管辖与其他
	  11.1本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
	  11.2您因使用两双筷子服务所产生及与两双筷子服务有关的争议，由两双筷子与您协商解决。协商不成时，任何一方均可向成都市高新区人民法院提起诉讼。
	  11.3本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
	  

	  `,
    };
  },
  methods: {},
};
</script>

<style scoped>
.agreement-container {
  padding: 20px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
}
.agreement-content {
  white-space: pre-wrap; /* 保留换行和空格 */
}
</style>
